/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Files_Details_TitleInputs */

const en_us2_builds_files_details_title = /** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File details`)
};

const es_es2_builds_files_details_title = /** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del archivo`)
};

const ru_builds_files_details_title = /** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сведения о файле`)
};

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const id_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const ms_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const da_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const de_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const es_mx2_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const fil_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const fr_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const it_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const hu_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const nl_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const no_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const pl_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const pt_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const pt_br2_builds_files_details_title = pt_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const ro_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const fi_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const sv_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const vi_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const tr_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const cs_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const bg_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const uk_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const ar_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const hi_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const th_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const ja_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const zh_cn2_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const zh_hant1_builds_files_details_title = en_us2_builds_files_details_title;

/** @type {(inputs: Builds_Files_Details_TitleInputs) => LocalizedString} */
const ko_builds_files_details_title = en_us2_builds_files_details_title;

/**
* | output |
* | --- |
* | "File details" |
*
* @param {Builds_Files_Details_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_files_details_title = /** @type {((inputs?: Builds_Files_Details_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Files_Details_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_files_details_title(inputs)
	if (locale === "ms") return ms_builds_files_details_title(inputs)
	if (locale === "da") return da_builds_files_details_title(inputs)
	if (locale === "de") return de_builds_files_details_title(inputs)
	if (locale === "en-US") return en_us2_builds_files_details_title(inputs)
	if (locale === "es-ES") return es_es2_builds_files_details_title(inputs)
	if (locale === "es-MX") return es_mx2_builds_files_details_title(inputs)
	if (locale === "fil") return fil_builds_files_details_title(inputs)
	if (locale === "fr") return fr_builds_files_details_title(inputs)
	if (locale === "it") return it_builds_files_details_title(inputs)
	if (locale === "hu") return hu_builds_files_details_title(inputs)
	if (locale === "nl") return nl_builds_files_details_title(inputs)
	if (locale === "no") return no_builds_files_details_title(inputs)
	if (locale === "pl") return pl_builds_files_details_title(inputs)
	if (locale === "pt-BR") return pt_br2_builds_files_details_title(inputs)
	if (locale === "pt") return pt_builds_files_details_title(inputs)
	if (locale === "ro") return ro_builds_files_details_title(inputs)
	if (locale === "fi") return fi_builds_files_details_title(inputs)
	if (locale === "sv") return sv_builds_files_details_title(inputs)
	if (locale === "vi") return vi_builds_files_details_title(inputs)
	if (locale === "tr") return tr_builds_files_details_title(inputs)
	if (locale === "cs") return cs_builds_files_details_title(inputs)
	if (locale === "bg") return bg_builds_files_details_title(inputs)
	if (locale === "ru") return ru_builds_files_details_title(inputs)
	if (locale === "uk") return uk_builds_files_details_title(inputs)
	if (locale === "ar") return ar_builds_files_details_title(inputs)
	if (locale === "hi") return hi_builds_files_details_title(inputs)
	if (locale === "th") return th_builds_files_details_title(inputs)
	if (locale === "ja") return ja_builds_files_details_title(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_files_details_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_files_details_title(inputs)
	return ko_builds_files_details_title(inputs)
});
export { builds_files_details_title as "builds.files.details.title" }